import type { HeaderFeaturesArticleHeadlineProps } from "scmp-app/components/header/features/article-headline";
import { HeaderFeaturesArticleHeadline } from "scmp-app/components/header/features/article-headline";
import { HeaderFeaturesBookmark } from "scmp-app/components/header/features/bookmark";
import type { HeaderFeaturesBookmarkProps } from "scmp-app/components/header/features/bookmark";
import type { HeaderFeaturesCommentProps } from "scmp-app/components/header/features/comment";
import { HeaderFeaturesComment } from "scmp-app/components/header/features/comment";
import { HeaderFeaturesDashboard } from "scmp-app/components/header/features/dashboard";
import type { HeaderFeaturesDashboardProps } from "scmp-app/components/header/features/dashboard";
import type { HeaderFeaturesEntityLinkProps } from "scmp-app/components/header/features/entity-link";
import { HeaderFeaturesEntityLink } from "scmp-app/components/header/features/entity-link";
import { HeaderFeaturesHamburgerMenu } from "scmp-app/components/header/features/hamburger-menu";
import type { HeaderFeaturesHamburgerMenuProps } from "scmp-app/components/header/features/hamburger-menu";
import { HeaderFeaturesLogoLink } from "scmp-app/components/header/features/logo-link";
import type { HeaderFeaturesLogoLinkProps } from "scmp-app/components/header/features/logo-link";
import { HeaderFeaturesLogoTextLink } from "scmp-app/components/header/features/logo-text-link";
import type { HeaderFeaturesLogoTextLinkProps } from "scmp-app/components/header/features/logo-text-link";
import { HeaderFeaturesMyNews } from "scmp-app/components/header/features/my-news";
import type { HeaderFeaturesMyNewsProps } from "scmp-app/components/header/features/my-news";
import type { HeaderFeaturesNewsletterProps } from "scmp-app/components/header/features/newsletter";
import { HeaderFeaturesNewsletter } from "scmp-app/components/header/features/newsletter";
import { HeaderFeaturesOneLineMenu } from "scmp-app/components/header/features/one-line-menu";
import type { HeaderFeaturesOneLineMenuProps } from "scmp-app/components/header/features/one-line-menu";
import { HeaderFeaturesSearch } from "scmp-app/components/header/features/search";
import type { HeaderFeaturesSearchProps } from "scmp-app/components/header/features/search";
import { HeaderFeaturesSearchBar } from "scmp-app/components/header/features/search-bar";
import type { HeaderFeaturesSearchBarProps } from "scmp-app/components/header/features/search-bar";
import type { HeaderFeaturesSectionEntityLinkProps } from "scmp-app/components/header/features/section-entity-link";
import { HeaderFeaturesSectionEntityLink } from "scmp-app/components/header/features/section-entity-link";
import type { HeaderFeaturesShareProps } from "scmp-app/components/header/features/share";
import { HeaderFeaturesShare } from "scmp-app/components/header/features/share";
import { HeaderFeaturesStyleLogoLink } from "scmp-app/components/header/features/style-logo-link";
import type { HeaderFeaturesStyleLogoLinkProps } from "scmp-app/components/header/features/style-logo-link";
import { HeaderFeaturesStyleTextLink } from "scmp-app/components/header/features/style-text-link";
import type { HeaderFeaturesStyleTextLinkProps } from "scmp-app/components/header/features/style-text-link";
import type { HeaderFeaturesSubscriptionProps } from "scmp-app/components/header/features/subscription";
import { HeaderFeaturesSubscription } from "scmp-app/components/header/features/subscription";
import type { HeaderFeaturesVideoEntityLinkProps } from "scmp-app/components/header/features/video-entity-link";
import { HeaderFeaturesVideoEntityLink } from "scmp-app/components/header/features/video-entity-link";

export const useHeaderFeaturesProvider = () => {
  const headerFeatureProvider = {
    articleHeadline: (props: HeaderFeaturesArticleHeadlineProps = {}) => (
      <HeaderFeaturesArticleHeadline {...props} />
    ),
    bookmark: (props: HeaderFeaturesBookmarkProps = {}) => <HeaderFeaturesBookmark {...props} />,
    comment: (props: HeaderFeaturesCommentProps = {}) => <HeaderFeaturesComment {...props} />,
    dashboard: (props: HeaderFeaturesDashboardProps = {}) => <HeaderFeaturesDashboard {...props} />,
    hamburgerMenu: (props: HeaderFeaturesHamburgerMenuProps = {}) => (
      <HeaderFeaturesHamburgerMenu {...props} />
    ),
    logoLink: (props: HeaderFeaturesLogoLinkProps = {}) => <HeaderFeaturesLogoLink {...props} />,
    logoTextLink: (props: HeaderFeaturesLogoTextLinkProps = {}) => (
      <HeaderFeaturesLogoTextLink {...props} />
    ),
    myNews: (props: HeaderFeaturesMyNewsProps = {}) => <HeaderFeaturesMyNews {...props} />,
    newsletter: (props: HeaderFeaturesNewsletterProps = {}) => (
      <HeaderFeaturesNewsletter {...props} />
    ),
    oneLineMenu: (props: HeaderFeaturesOneLineMenuProps = {}) => (
      <HeaderFeaturesOneLineMenu {...props} />
    ),
    search: (props: HeaderFeaturesSearchProps = {}) => <HeaderFeaturesSearch {...props} />,
    searchBar: (props: HeaderFeaturesSearchBarProps) => <HeaderFeaturesSearchBar {...props} />,
    section: (props: HeaderFeaturesEntityLinkProps = {}) => <HeaderFeaturesEntityLink {...props} />,
    sectionEntityLink: (props: HeaderFeaturesSectionEntityLinkProps = {}) => (
      <HeaderFeaturesSectionEntityLink {...props} />
    ),
    share: (props: HeaderFeaturesShareProps = {}) => <HeaderFeaturesShare {...props} />,
    styleLogoLink: (props: HeaderFeaturesStyleLogoLinkProps = {}) => (
      <HeaderFeaturesStyleLogoLink {...props} />
    ),
    styleTextLink: (props: HeaderFeaturesStyleTextLinkProps = {}) => (
      <HeaderFeaturesStyleTextLink {...props} />
    ),
    subscription: (props: HeaderFeaturesSubscriptionProps = {}) => (
      <HeaderFeaturesSubscription {...props} />
    ),
    videoEntityLink: (props: HeaderFeaturesVideoEntityLinkProps = {}) => (
      <HeaderFeaturesVideoEntityLink {...props} />
    ),
  };
  return headerFeatureProvider;
};
